import { NormalSelectOptions } from "@app/components/select/select.type";
import { Role } from "./common.const";

export const UserOption = {
  FREE: false,
  VIP: true,
} as const;

export type UserOption = (typeof UserOption)[keyof typeof UserOption];

export enum UserOptionName {
  FREE = "Miễn phí",
  VIP = "VIP",
}

export enum UserOptionNameString {
  FREE = "FREE",
  VIP = "VIP",
}

export const UsersOptionName = Object.freeze({
  [UserOption.FREE.toString()]: UserOptionName.FREE,
  [UserOption.VIP.toString()]: UserOptionName.VIP,
});

export const UserOptions: NormalSelectOptions = [
  { label: UserOptionName.FREE, value: UserOption.FREE.toString() },
  { label: UserOptionName.VIP, value: UserOption.VIP.toString() },
];

export const UserOptionsString: NormalSelectOptions = [
  { label: UserOptionName.FREE, value: UserOptionNameString.FREE },
  { label: UserOptionName.VIP, value: UserOptionNameString.VIP },
];

export enum RoleOptionName {
  USER = "User",
  AUTHOR = "Author",
  ADMIN_ROOT = "Admin Root",
  ADMIN = "Admin",
}

export const RoleOptions: NormalSelectOptions = [
  { label: RoleOptionName.USER, value: Role.USER.toString() },
  { label: RoleOptionName.AUTHOR, value: Role.AUTHOR.toString() },
  { label: RoleOptionName.ADMIN, value: Role.ADMIN.toString() },
  { label: RoleOptionName.ADMIN_ROOT, value: Role.ADMIN_ROOT.toString() },
];

export enum StatusOptionName {
  BANNED = "Banned",
  PENDING = "Pending",
  APPROVE = "Approved",
}

export enum UserStatus {
  BANNED = 1,
  PENDING = 2,
  APPROVE = 3,
}

export const StatusOptions: NormalSelectOptions = [
  { label: StatusOptionName.BANNED, value: UserStatus.BANNED.toString() },
  { label: StatusOptionName.PENDING, value: UserStatus.PENDING.toString() },
  { label: StatusOptionName.APPROVE, value: UserStatus.APPROVE.toString() },
];

export const ActiveOption = {
  ACTIVE: true,
  IN_ACTIVE: false,
} as const;

export type ActiveOption = (typeof ActiveOption)[keyof typeof ActiveOption];

export enum ActiveOptionName {
  ACTIVE = "Active",
  IN_ACTIVE = "Inactive",
}

export const ActiveOptions: NormalSelectOptions = [
  { label: ActiveOptionName.ACTIVE, value: ActiveOption.ACTIVE.toString() },
  {
    label: ActiveOptionName.IN_ACTIVE,
    value: ActiveOption.IN_ACTIVE.toString(),
  },
];
